import { Observable } from 'rxjs';
import { Image } from '@fitscovery/common/types';

export abstract class AbstractImageService {

  downloadUrl: Observable<string>;
  uploadPercent: Observable<number>;

  abstract getSasToken(token?: string): Observable<string>;

  abstract uploadImage(image: Image, sasToken?: any, folder?: string): Observable<any>;
}
